import actionTypes from "../webActionTypes";


const reducers = {
    [actionTypes.beginCheckPrizedInvoice]: function (state, action) {
      return beginCheckPrizedInvoice(state, action);
    },

    [actionTypes.recvCheckPrizedInvoiceResult]: function (state, action) {
        return recvCheckPrizedInvoiceResult(state, action);
    },

    [actionTypes.recvCheckPrizedInvoiceError]: function (state, action) {
        return recvCheckPrizedInvoiceError(state, action);
    },
  


    [actionTypes.beginGetPrizedInvoiceList]: function (state, action) {
        return beginGetPrizedInvoiceList(state, action);
    },

    [actionTypes.recvGetPrizedInvoiceListResult]: function (state, action) {
        return recvGetPrizedInvoiceListResult(state, action);
    },

    [actionTypes.recvGetPrizedInvoiceListError]: function (state, action) {
        return recvGetPrizedInvoiceListError(state, action);
    },
    [actionTypes.finishGetInvoicePrizeYearmonthList]: function (state, action) {
        return finishGetInvoicePrizeYearmonthList(state, action);
    },
};

export default function createReducers(initialState) {
    return function reducer(state = initialState, action) {
        if (reducers.hasOwnProperty(action.type)) {
            return reducers[action.type](state, action);
        } else {
            return state;
        }
    };
}


function beginGetPrizedInvoiceList(state, action) {
    if (state.isCheckPrizedInvoice) return state;

    return Object.assign({}, state, {
        isGetPrizedInvoiceList: true
    });
}

function recvGetPrizedInvoiceListResult(state, action) {

    const {
        payload
    } = action;

    const {totalCount, querykey, ids, data} = payload;

    if (ids.length === 0) {
        return state;
    }
    
    var prizedInvoiceList;

    if(querykey === state.querykey) {
        prizedInvoiceList = Object.assign({}, state.prizedInvoiceList, ids);        
    } else {
        prizedInvoiceList = Object.assign({}, {}, ids);
    }

    const prizedInvoices = Object.assign({}, state.prizedInvoices, data);

    return Object.assign({}, state, {
        prizedInvoiceList,
        prizedInvoices,
        totalCount,
        querykey,
        isGetPrizedInvoiceList: false,
    });
}


function recvGetPrizedInvoiceListError(state, action) {
    if (!state.isCheckPrizedInvoice) return state;

    return Object.assign({}, state, {
        isGetPrizedInvoiceList: false
    });
}

function beginCheckPrizedInvoice(state, action) {
    if (state.isCheckPrizedInvoice) return state;

    return Object.assign({}, state, {
        isCheckPrizedInvoice: true
    });
}


function recvCheckPrizedInvoiceResult(state, action) {
    if (!state.isCheckPrizedInvoice) return state;

    return Object.assign({}, state, {
        isCheckPrizedInvoice: false,
    });
}


function recvCheckPrizedInvoiceError(state, action) {
    if (!state.isCheckPrizedInvoice) return state;

    return Object.assign({}, state, {
        isCheckPrizedInvoice: false,
    });
}

function finishGetInvoicePrizeYearmonthList(state, action) {

    const payload = action.payload;
    const yearmonthList = payload.yearmonthList || [];

    return Object.assign({}, state, {
        yearmonthList: yearmonthList,
    });
}


// WEBPACK FOOTER //
// ./src/actions/reducers/prizedInvoiceReducers.js